import * as types from 'actions/types';
import { createReducer, successType } from 'shared/lib/lib/callAPI';
import { combineReducers } from 'redux';

const byInternship = (state = {}, action) => {
  switch (action.type) {
    case successType(types.GET_APPLICANT_LEARNING_TASK):
      return {
        ...state,
        [action.response.internshipId]: { ...action.response.data },
      };
    case types.UPDATE_APPLICANT_LEARNING_TASK:
      // eslint-disable-next-line no-case-declarations
      const internshipId = action.data.pk;
      return {
        ...state,
        [internshipId]: {
          ...(state[internshipId] || {}),
          ...action.data,
        },
      };
    case types.LOGOUT:
      return {};
    default:
      return state;
  }
};

const dataReducer = combineReducers({
  byInternship,
});

export default createReducer(types.GET_APPLICANT_LEARNING_TASK, dataReducer,);
